import { render } from "./VeganSummary.vue?vue&type=template&id=c31df312"
import script from "./VeganSummary.vue?vue&type=script&lang=js"
export * from "./VeganSummary.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__